import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    stabilizedsandLength: string;
    stabilizedsandWidth: string;
    stabilizedsandThickness: string;
};

const Calculation = ({
    setCalculationValue,
    stabilizedsandLength,
    stabilizedsandWidth,
    stabilizedsandThickness
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col>
                    <h3 className="d-sm-block">
                        {t(
                            "calculator.stabilizedsandCalculator.stabilizedsandMeasurements"
                        )}
                    </h3>
                </Col>
            </Row>
            <Row>
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"stabilizedsandLength"}
                    dimension={"length"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={stabilizedsandLength}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"stabilizedsandWidth"}
                    dimension={"width"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={stabilizedsandWidth}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"stabilizedsandThickness"}
                    dimension={"thickness"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    value={stabilizedsandThickness}
                />
            </Row>
        </div>
    );
};

export default Calculation;
